import ConnectApi from "../baseService"
import { AxiosResponse } from "axios"

/**
 *
 * ContentService
 * @export
 * @class ContentService
 * @extends {ConnectApi}
 */
export default class ContentService extends ConnectApi {
  constructor() {
    super({ responseType: "blob" })
  }

  /**
   * Get処理
   * @returns File
   */
  get = async (filePath: string) => {
    try {
      const res: AxiosResponse<Blob> = await this.postInner(`content`, {
        filePath: filePath,
      })

      return res.data
    } catch (error) {
      throw error
    }
  }
}
